export var Align = {
  Left: 'left',
  Center: 'center',
  Right: 'right'
};